var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGlobe = function SvgGlobe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.5,
    height: 27.5,
    viewBox: "0 0 27.459 27.459"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "globe_svg__a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcca46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7f2d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "globe_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#globe_svg__a)",
    d: "M0 0h27.459v27.459H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#globe_svg__b)",
    fill: "url(#globe_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.871 1.249 2.407.56c-.295 1.253.292 2.419 1.991 3.636 3.963 2.839 4.9 4.439 3.773 7.977-.665 2.083.141 2.845 2.921 2.845v2.457c-4.268 0-6.524-2.134-5.277-6.044.727-2.282.335-2.952-2.861-5.241-2.442-1.749-3.5-3.857-2.953-6.189"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.691 11.633a11.243 11.243 0 0 0 14.493 12.789c-.691-1.6-1.443-1.953-2.846-1.913-.171 0-.317.012-.637.032-2.418.146-3.622-.156-4.76-1.884-1.271-1.931-.872-3.326.661-5.1l.182-.21c1.144-1.311 1.253-1.719.423-2.913-.929-1.335-1.444-1.407-3.384-.852-1.822.521-2.99.635-4.133.047m.771-2.469c.627.478 1.183.449 2.676.022 2.85-.815 4.435-.594 6.119 1.827 1.633 2.347 1.218 3.907-.591 5.98l-.177.2c-.887 1.023-.97 1.316-.463 2.088.5.756.917.862 2.524.764.346-.02.51-.029.717-.035 2.388-.068 4.032.824 5.184 3.385A11.235 11.235 0 1 0 3.462 9.164m10.267 18.295A13.729 13.729 0 1 1 27.458 13.73a13.729 13.729 0 0 1-13.729 13.729"
  }))));
};

export default SvgGlobe;